//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import editHover from "@/assets/images/Buttons/editHover.svg";
import deleteHover from "@/assets/images/Buttons/deleteHover.svg";
import downloadHover from "@/assets/images/Buttons/downloadHover.svg";
import copyHover from "@/assets/images/Buttons/copyHover.svg";
import moreHover from "@/assets/images/Buttons/moreHover.svg";
import deleteS from "@/assets/images/Buttons/deleteS.svg";
import deleteDisabled from "@/assets/images/Buttons/deleteDisabled.svg";
import edit from "@/assets/images/Buttons/edit.svg";
import editDisabled from "@/assets/images/Buttons/editDisabled.svg";
import download from "@/assets/images/Buttons/download.svg";
import downloadDisabled from "@/assets/images/Buttons/downloadDisabled.svg";
import copy from "@/assets/images/Buttons/copy.svg";
import copyDisabled from "@/assets/images/Buttons/copyDisabled.svg";
import more from "@/assets/images/Buttons/more.svg";
import moreDisabled from "@/assets/images/Buttons/moreDisabled.svg";

export default {
    name: "AQListBtn",
    components: {
        AQTooltip,
        AQMenu
    },
    props: {
        hideAllBtn: { type: Boolean, default: false },
        hideList: { type: Array, default: () => [] }, // list of buttons to hide
        optionsMore: { type: Array, default: () => [] }, // option for more btn
        deleteBtnCustomTooltip: { type: String, default: "" },
        disableBtns: { type: Boolean, default: false }, // disable all visible btns
        disableEdit: { type: Boolean, default: false },
        disableDownload: { type: Boolean, default: false },
        disableCopy: { type: Boolean, default: false },
        disableDelete: { type: Boolean, default: false },
        disableMore: { type: Boolean, default: false },
        customCopyLabel: { type: String, default: "" },
        customDownloadLabel: { type: String, default: "" }
    },
    data() {
        return {
            badgeColor: "var(--q-color-chip-default-text)",
            hovered: null,
            moreMenu: false,
            showMenu: [],
            anchorOrigin: { vertical: "bottom", horizontal: "right" },
            selfOrigin: { vertical: "top", horizontal: "right" },
            buttons: [
                { img: edit,
                    imgHover: editHover,
                    imgDisabled: editDisabled,
                    name: "edit",
                    label: this.$t("btnListComponents.edit"),
                    disabled: this.disableEdit },
                { img: download,
                    imgHover: downloadHover,
                    imgDisabled: downloadDisabled,
                    name: "download",
                    label: this.customDownloadLabel || this.$t("btnListComponents.download"),
                    disabled: this.disableDownload },
                { img: copy,
                    imgHover: copyHover,
                    imgDisabled: copyDisabled,
                    name: "copy",
                    label: this.customCopyLabel || this.$t("btnListComponents.copy"),
                    disabled: this.disableCopy },
                { img: deleteS,
                    imgHover: deleteHover,
                    imgDisabled: deleteDisabled,
                    name: "delete",
                    label: this.$t("btnListComponents.delete"),
                    disabled: this.disableDelete },
                { img: more,
                    imgHover: moreHover,
                    imgDisabled: moreDisabled,
                    name: "more",
                    label: this.$t("btnListComponents.more"),
                    disabled: this.disableMore }
            ]// all type of buttons
        };
    },

    computed: {
        buttonsShow() {
            let btnToReturn = [];
            if (!this.hideAllBtn) {
                let filterBtns = [];
                if (this.hideList && this.hideList.length) {
                    filterBtns = this.buttons.filter(elem => this.hideList.indexOf(elem.name) === -1);
                }

                btnToReturn = filterBtns && filterBtns.length ? filterBtns : this.buttons;
                if (this.disableBtns) {
                    btnToReturn = btnToReturn.map(btn => {
                        btn.disabled = this.disableBtns;
                        return btn;
                    });
                }
            }
            return btnToReturn;
        }

    },
    methods: {
        click(event, btn) {
            if (btn) {
                if (!btn.disabled) {
                    this.clickedBtns(event, btn);
                }
            } else {
                this.clickedMenu(event);
            }
        },
        clickedBtns(event, action) {
            if (action.name === "more") {
                this.moreMenu = !this.moreMenu;
                if (this.moreMenu) {
                    this.$emit("click", action.name);
                } else {
                    this.$emit("click", null);
                }
            } else {
                this.moreMenu = false;
                event.stopPropagation();
                this.$emit("click", action.name);
            }
            this.more = false;
        },
        clickedMenu(action) {
            if (action && action.name) {
                this.$emit("click", action.name);
            }
        },
        hideMenu() {
            this.moreMenu = false;
            this.$emit("hideMenu");
        }
    }
};
